import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, AfterViewChecked, Input, OnChanges } from '@angular/core';
import { IonContent, DomController } from '@ionic/angular';

import { Helpers, BaseComponent } from 'ngx-elvis-ds';
import { ThemeService } from 'ngx-elvis-ds';
import { CartService } from 'src/app/services/cart.service';
import { SAMSessionService } from 'src/app/sam/sam-session.service';
import { SAMService } from 'src/app/sam/sam.service';
import { ConfigService } from 'src/app/config.service';
import { DeviceType } from 'src/app/base/device-type.enum';
import { I18NService } from 'src/app/services/i18n.service';

@Component({
  selector: 'elv-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent extends BaseComponent implements AfterViewInit {

  @ViewChild('cart', { static: true }) cart: ElementRef;
  @ViewChild('receipt', { static: true }) receipt: ElementRef;
  @ViewChild('content', { static: true }) content: IonContent;

  @Input()
  itemHeight: number = 60;

  @Input()
  enterTimeout: number = 1000;
  
  @Input()
  noMargin: boolean = false;

  @Input()
  displayIndex: boolean = true;

  private _visible = false;

  constructor(
    public samSessionSvc: SAMSessionService,
    public sam: SAMService,
    public cartSvc: CartService,
    public themeSvc: ThemeService,
    public configSvc: ConfigService,
    private domCtrl: DomController,
    public i18nSvc: I18NService
  ) {
    super();
  }

  ngAfterViewInit() {
    window.addEventListener('resize', () => { this.setReceiptMargin(); });

    this.domCtrl.write(() => {
      this.receipt.nativeElement.style.setProperty(`--cart-item-height`, `${this.itemHeight}px`);
      this.receipt.nativeElement.style.setProperty(`--cart-follow-up-item-height`, `${this.itemHeight*0.6}px`);

      const elmt = document.querySelector('#elv-cart');
      Helpers.hideScrollbars(elmt);
    });

    this.cartSvc.events.subscribe(() => {
      this.setReceiptMargin();
    });

    setTimeout(() => {
      this.setReceiptMargin();
    }, 500);

    
  }

  // private

  private setReceiptMargin() {
    this.domCtrl.write(() => {
      const cartSizes = this.cart.nativeElement.getBoundingClientRect();
      // const receiptSizes = this.receipt.nativeElement.getBoundingClientRect();
      const cartMargin = this.noMargin ? 0 : 40;
      const newReceiptMargin = + cartSizes.height - (this.cartSvc.cart.length * this.itemHeight) - cartMargin - (this.cartSvc.cart.length === 0 ? this.itemHeight : 0);

      this.receipt.nativeElement.style.transform = `translate3D(0, ${Math.max(newReceiptMargin, 0)}px, 0)`;

      if (newReceiptMargin < 0 && cartSizes.height) {
        setTimeout(() => {
          this.content.scrollToBottom(1000);
        }, 100);
      } else {
        this.receipt.nativeElement.style.transform = `translate3D(0, ${Math.max(newReceiptMargin, 0)}px, 0)`;
      }

      if (!this._visible) {
        setTimeout(() => {
          this.receipt.nativeElement.classList.add('visible');
          this._visible = true;
        }, this.enterTimeout);
      }
    });
  }

}
